import { useContext } from 'react';

import { RouteContext } from '../components/RouteContext';

export function useRouteContext() {
  return useContext(RouteContext);
}
